import { create } from 'zustand';

export const useSchedulesStore = create((set) => ({

    schedules: {},

    setSchedule: schedule => {

        if (!schedule?.redisKey) {
            return;
        }

        set(state => ({
            schedules: {
                ...state.schedules,
                [schedule.redisKey]: schedule
            }
        }));

    },

    removeSchedule: redisKey => {

        if (!redisKey) {
            return;
        }

        set(state => {

            if (!(redisKey in state.schedules)) {
                return state;
            }

            const schedules = {
                ...state.schedules
            };

            delete schedules[redisKey];

            return { schedules };

        });

    }

}));